"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2776,2968],{

/***/ 52776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RegularTabsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js + 1 modules
var two_thirds_text_and_asset_component = __webpack_require__(32968);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/regular-tabs-component.scss.js


var StyledRegularTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1h7cbvi0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.large-screen-component-wrapper{display:block;}.small-screen-component-wrapper{display:none;.two-third-text-and-asset-component-wrapper{.tab-label-container{display:flex;justify-content:center;.tab-label{font-weight:700;font-size:1.375rem;position:relative;z-index:1;margin-bottom:50px;.tab-label-underline{bottom:-10px;right:-20px;left:-20px;height:5px;background-color:blue;position:absolute;z-index:2;}}}&:not(:last-child){margin-bottom:60px;}.full-paragraph{text-align:center;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.large-screen-component-wrapper{display:none;}.small-screen-component-wrapper{display:block;}}");

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props.js
var default_props = __webpack_require__(427);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/deafult-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var deafult_props = (_object_spread_props(_object_spread({}, tabs_component/* default.defaultProps */.Z.defaultProps), {
    tabsColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
    tabs: [
        {
            tabLabel: "Clients Projects",
            textAndAsset: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
                fullParagraph: _object_spread_props(_object_spread({}, default_props/* default.fullParagraph */.Z.fullParagraph), {
                    topic: {},
                    title: "Accurately estimate costs and increase profitability",
                    body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
                }),
                asset: _object_spread_props(_object_spread({}, default_props/* default.asset */.Z.asset), {
                    position: "center"
                })
            })
        },
        {
            tabLabel: "Content Planning",
            textAndAsset: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
                fullParagraph: _object_spread_props(_object_spread({}, default_props/* default.fullParagraph */.Z.fullParagraph), {
                    topic: {},
                    title: "Plan your content in advance for maximum productivity",
                    body: "Organize all your content pieces by channel and publish date. Easily assign writers, designers, and editors to every post."
                }),
                asset: _object_spread_props(_object_spread({}, default_props/* default.asset */.Z.asset), {
                    position: "center"
                })
            })
        }
    ],
    paddingTop: "64px"
}));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/regular-tabs-component.js




function regular_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_tabs_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_tabs_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_tabs_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var MINIMUN_NUM_OF_TABS_FOR_SMALL_LABELS = 5;
var RegularTabsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RegularTabsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RegularTabsComponent);
    function RegularTabsComponent() {
        (0,_class_call_check/* default */.Z)(this, RegularTabsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(RegularTabsComponent, [
        {
            key: "tabsRenderer",
            value: function tabsRenderer() {
                var _props = this.props, theme = _props.theme, tabs = _props.tabs, tabsColor = _props.tabsColor, tabsBackgroundColor = _props.tabsBackgroundColor;
                var useSmallLabels = tabs.length >= MINIMUN_NUM_OF_TABS_FOR_SMALL_LABELS;
                return tabs.map(function(tab, index) {
                    var tabLabel = tab.tabLabel, textAndAsset = tab.textAndAsset, tabId = tab.tabId;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                        theme: theme,
                        tabId: tabId,
                        label: tabLabel,
                        color: tabsColor,
                        backgroundColor: tabsBackgroundColor,
                        useSmallLabels: useSmallLabels,
                        children: /*#__PURE__*/ (0,react.createElement)(two_thirds_text_and_asset_component["default"], regular_tabs_component_object_spread_props(regular_tabs_component_object_spread({}, textAndAsset), {
                            key: index
                        }))
                    }, index);
                });
            }
        },
        {
            key: "renderTwoThirdsComponents",
            value: function renderTwoThirdsComponents() {
                var _props = this.props, tabs = _props.tabs, tabsColor = _props.tabsColor;
                return tabs.map(function(tab, index) {
                    var tabLabel = tab.tabLabel, textAndAsset = tab.textAndAsset;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "two-third-text-and-asset-component-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tab-label-container",
                                style: {
                                    color: colors/* default */.Z[tabsColor]
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tab-label",
                                    children: [
                                        tabLabel,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-label-underline",
                                            style: {
                                                backgroundColor: colors/* default */.Z[tabsColor]
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(two_thirds_text_and_asset_component["default"], regular_tabs_component_object_spread({}, textAndAsset))
                        ]
                    }, index);
                });
            }
        },
        {
            key: "renderLargeScreenComponent",
            value: function renderLargeScreenComponent() {
                var _props = this.props, autoTransition = _props.autoTransition, scrollOnTabClick = _props.scrollOnTabClick, scrollSpeed = _props.scrollSpeed, distanceFromTop = _props.distanceFromTop, activeTabId = _props.activeTabId;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "large-screen-component-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
                        autoTransition: autoTransition,
                        scrollOnTabClick: scrollOnTabClick,
                        scrollSpeed: scrollSpeed,
                        distanceFromTop: distanceFromTop,
                        activeTabId: activeTabId,
                        role: "tabpanel",
                        children: this.tabsRenderer()
                    })
                });
            }
        },
        {
            key: "renderSmallScreenComponent",
            value: function renderSmallScreenComponent() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "small-screen-component-wrapper",
                    children: this.renderTwoThirdsComponents()
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegularTabsComponent, {
                    className: "regular-tabs-component",
                    children: [
                        this.renderLargeScreenComponent(),
                        this.renderSmallScreenComponent()
                    ]
                });
            }
        }
    ]);
    return RegularTabsComponent;
}(react.PureComponent);

RegularTabsComponent.defaultProps = deafult_props;


/***/ }),

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38305);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    fullParagraph: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].fullParagraph */ .Z.fullParagraph), {
        topic: {
            text: "For the creative process",
            color: "brand-blue"
        },
        title: "Streamline your creative workflow",
        body: "Use customizable forms to request all the information needed. Then, easily share assets and receive feedback in real time."
    }),
    asset: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset */ .Z.asset), {
        image: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset.image */ .Z.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
        })
    })
}));


/***/ }),

/***/ 32968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TwoThirdsTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.scss.js

var StyledTwoThirdsTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emxkgw60"
})(".side-by-side-text-and-asset-component{.side-by-side-content{.full-paragraph-component-wrapper{width:40%;}.image-wrapper{width:60%;}&.no-text-component{justify-content:center;.image-wrapper{width:100%;}}}}");

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props.js
var default_props = __webpack_require__(427);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var TwoThirdsTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoThirdsTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoThirdsTextAndAssetComponent);
    function TwoThirdsTextAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, TwoThirdsTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoThirdsTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoThirdsTextAndAssetComponent, {
                    className: "two-thirds-text-and-asset-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], _object_spread({}, this.props))
                });
            }
        }
    ]);
    return TwoThirdsTextAndAssetComponent;
}(react.PureComponent);

TwoThirdsTextAndAssetComponent.defaultProps = default_props/* default */.Z;


/***/ })

}]);